module.exports = __webpack_public_path__ + "static/shift_icon-5c4f0ee7999991f07c20e8ced629e10c.svg";